import request from '@/router/axios'
import env from '@/config/env'

// 渠道列表分页
export function userSourcePage(data) {
  return request({
    url: env.ferryUrl + '/user-source/manage/page',
    method: 'post',
    data
  })
}

// 新增渠道
export function userSourceSave(data) {
  return request({
    url: env.ferryUrl + '/user-source/manage/save',
    method: 'post',
    data
  })
}

// 删除渠道
export function userSourceDelete(id) {
  return request({
    url: env.ferryUrl + `/user-source/manage/delete/${id}`,
    method: 'delete'
  })
}
